module.exports = __webpack_public_path__ + "img/sn.09cb179a.svg";